import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { Separator } from '@root/shared/ui-kit'

import { PremiumCardHeaderSkeleton } from '../premium-card-header/premium-card-header-skeleton'

import { ExpiredPremiumCardRoot } from './expired-premium-card'

export const ExpiredPremiumCardSkeleton: React.FC = () => {
  return (
    <ExpiredPremiumCardRoot>
      <PremiumCardHeaderSkeleton />
      <Separator />
      <Bottom>
        <Button width={105} height={32} />
        <ExpiredAt width={60} height={8} />
      </Bottom>
    </ExpiredPremiumCardRoot>
  )
}

const Bottom = styled.footer`
  display: grid;
  align-items: center;
  justify-content: center;

  gap: 8px;
  padding: 0 12px 0 16px;
`

const Button = styled(Skeleton)`
  border-radius: 24px;
`
const ExpiredAt = styled(Skeleton)`
  justify-self: center;
`
